(function () {
    'use strict';

    angular.module('swif.patrimoine')
    .directive('panelPatrimoineSite', panelPatrimoineSite);

    /**
     *
     * @ngdoc directive
     * @name swif.patrimoine:panelPatrimoineSite
     * @module swif.patrimoine
     * @descrition
     * This component display the patrimoine_site in a panel with all extra data
     * @restrict E
     */
    function panelPatrimoineSite($sce, swif, swifRouteService, swifCartoLeafletService, swifOpenbaseKeysService, openbase) {
        'ngInject';
        var params = {};
        var directive = swif.panel.create_directive('patrimoine_site', params);
        var oldLink = directive.link;
        directive.link = function (scope, element, attr, ngModel) {
            oldLink(scope, element, attr, ngModel);
            var render = ngModel.$render;
            ngModel.$render = function () {
                render();
                var url, geo, args, bbox;
                //reset
                scope.route = swifRouteService;
                scope.dimensions = false;
                scope.attachments = [];
                scope.images = [];
                scope.purchase = false;
                scope.sale = false;
                scope.hasCadastre = false;
                scope.geoloc = false;
                scope.keys = [];
                if (scope.item === undefined) {
                    return;
                }
                // Attachments
                swif.attachment.getAttachments(scope.item)
                .then(function (attachments) {
                    scope.attachments = attachments.attachments;
                    scope.images = swif.attachment.getImages(scope.attachments);
                    if (scope.images) {
                        scope.extra = 'photos';
                    }
                });
                // Keys
                var keysFilter = {};
                swif.data.addExtraFilter(keysFilter, 'site', 'site_ids', 'in', [scope.item.id])
                swifOpenbaseKeysService.createCollection(scope.item.id, keysFilter)
                .then(function(collection) {
                    scope.keys = collection.items;
                })
                // Acquisition
                _.forOwn(scope.item, function (value, key) {
                    if (value) {
                        if (key.indexOf('purchase_') !== -1) {
                            scope.purchase = true;
                        }
                        if (key.indexOf('sale_') !== -1) {
                            scope.sale = true;
                        }
                    }
                });
                // Dimension
                if (scope.item.width && scope.item.length) {
                    scope.dimensions = true;
                }
                // Carte
                if (scope.item.geo_point) {
                    scope.geoloc = true;
                }

                // State
                scope.STATES = {};
                var statesConfig = openbase.equipment.getStatesConfig();
                _.forEach(statesConfig, function (item) {
                    scope.STATES[item.id] = item.name;
                });
                // This seems to be dead code... geo or osmUrl is never used
                if (scope.item.geo) {
                    geo = scope.item.geo;
                    args = '';
                    url = 'https://www.geoportail.gouv.fr/embed/visu.html';
                    args = '?c=' + geo.lon + ',' + geo.lat;
                    args += '&z=0.000005';
                    args += '&l=CADASTRALPARCELS.PARCELS::GEOPORTAIL:OGC:WMTS(1)&permalink=yes';
                    url += args;
                    scope.geoPortailUrl = $sce.trustAsResourceUrl(url);
                    url = 'https://www.geoportail.gouv.fr/donnee/50/parcelles-cadastrales';
                    url += args;
                    scope.geoPortailLink = $sce.trustAsResourceUrl(url);
                    scope.hasCadastre = true;
                    url = 'https://www.openstreetmap.org/export/embed.html';
                    bbox = '?bbox=' + (geo.lon - 0.00058) + '%2C' + (geo.lat - 0.00033) + '%2C' + (geo.lon + 0.00058) + '%2C' + (geo.lat + 0.00033);
                    url += bbox;
                    url += '&amp;layer=mapnik&amp;marker=';
                    url += '' + geo.lat + '%2C' + geo.lon;
                    scope.osmUrl = $sce.trustAsResourceUrl(url);
                    url = 'https://www.openstreetmap.org/';
                    url += '?mlat=' + geo.lat + '&amp;mlon=' + geo.lon;
                    url += '#map=19/' + geo.lat + '/' + geo.lon;
                    scope.osmLink = $sce.trustAsResourceUrl(url);
                } else {
                    delete scope.cadastreUrl;
                    delete scope.osmUrl;
                    delete scope.cadastreLink;
                    delete scope.osmLink;
                }
                var com = scope.item.cadastre_commune;
                if (com) {
                    var c = scope.item;
                    var initSession = function (commune) {
                        url = 'https://www.cadastre.gouv.fr/scpc/rechercherPlan.do';
                        url += '?numeroVoie=';
                        url += '&indiceRepetition=';
                        url += '&nomVoie=';
                        url += '&lieuDit=';
                        url += '&ville=' + commune.name;
                        url += '&codeCommune=' + commune.code;
                        url += '&codePostal=' + commune.zip;
                        url += '&codeDepartement=0' + commune.zip.slice(0,2);
                        url += '&nbResultatParPage=5';
                        scope.cadastreInitSessionUrl = $sce.trustAsResourceUrl(url);
                        scope.hasCadastre = true;
                        return commune;
                    };
                    var addFeuilleLink = function (commune) {
                        var id = scope.item.cadastre_feuille[0];
                        return swif.data.get('patrimoine_cadastre_feuille', id).then(function(feuille) {
                            scope.cadastre_feuille = feuille;
                            if (feuille.section){
                                return swif.data.get('patrimoine_cadastre_section', feuille.section[0])
                                    .then(function (section) {
                                        var f = commune.code + feuille.prefix + section.name + feuille.name;
                                        url = 'https://www.cadastre.gouv.fr/scpc/afficherCarteFeuille.do';
                                        url += '?f=' + f;
                                        url += '&dontSaveLastForward&keepVolatileSession=';
                                        scope.cadastreFeuilleUrl = $sce.trustAsResourceUrl(url);
                                        return commune;
                                    });
                            }
                        });
                    };
                    var addParcelleLink = function (commune) {
                        if (commune){
                            var id = scope.item.cadastre_section[0];
                            return swif.data.get('patrimoine_cadastre_section', id).then(function(section) {
                                scope.cadastre_section = section;
                                var feuille = scope.cadastre_feuille;
                                var p = commune.code + feuille.prefix + section.name + c.cadastre_id;
                                var f = commune.code + feuille.prefix + section.name + feuille.name;
                                url = 'https://www.cadastre.gouv.fr/scpc/afficherCarteParcelle.do';
                                url += '?f=' + f;
                                url += '&p=' + p;
                                url += '&dontSaveLastForward&keepVolatileSession=';
                                scope.cadastreParcelleUrl = $sce.trustAsResourceUrl(url);
                                return commune;
                            });
                        }
                    };
                    var promise = swif.data.get('patrimoine_cadastre_commune', com[0]).then(initSession);
                    if (c.cadastre_feuille) {
                        promise = promise.then(addFeuilleLink);
                    }
                    if (c.cadastre_section && c.cadastre_id) {
                        promise = promise.then(addParcelleLink);
                    }
                }
            };
            scope.setDisplay = function (content) {
                if (content==='geoloc'){
                    this.route.check({resources: ['leaflet']}).then(function () {
                        scope.extra = content;
                    });
                }else{
                    scope.extra = content;
                }
            };

            scope.onMapInitialized = function (map) {
                scope.map = map;
                if (scope.item.osm_zoom) {
                    scope.map.setZoom(scope.item.osm_zoom);
                }
                if (scope.item.geo_point) {
                    let marker = swifCartoLeafletService.getMarkerFromPoint(scope.item.geo_point);
                    if (marker) {
                        marker.addTo(scope.map);
                        scope.map.setView(marker.getLatLng());
                    }
                }
            };
        };
        directive.templateUrl = 'partials/patrimoine/panel-patrimoine-site.html';
        return directive;
    }

})();
